module.exports = __webpack_public_path__ + "img/date_left.1b391667.png";